<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'SSOWeb',
    components: {
        
    },
    data: function() {
        return {
            
        };
    },

    created: function() {
        
    },
};
</script>

<style>

body {
    margin: 0;
    padding: 0;
    font-family: Avenir, Helvetica, Arial, 'PingFang SC', 'Noto Sans SC', '微软雅黑', sans-serif;
}

#app {
    font-family: Avenir, Helvetica, Arial, 'PingFang SC', 'Noto Sans SC', '微软雅黑', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

</style>
